(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stockists"] && !Shopify.designMode) return;
  try {
    
// Leaflet and its tiles are fetched only when the map scrolls into view, and
// only once. If the CDN fails the list beside it is unaffected.
(function () {
  var box = document.querySelector('[data-stock-map]');
  if (!box) return;

  var CSS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
  var JS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
  var map = null, markers = [], loading = false;

  function items() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-stock-item]'));
  }

  function build() {
    if (map || !window.L) return;
    var pts = items().filter(function (el) { return el.dataset.lat && el.dataset.lng; });
    map = L.map(box, { scrollWheelZoom: false });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);

    pts.forEach(function (el, i) {
      var m = L.marker([parseFloat(el.dataset.lat), parseFloat(el.dataset.lng)], {
        icon: L.divIcon({
          className: '',
          html: '<span class="sear-stock__pin">' + (i + 1) + '</span>',
          iconSize: [26, 26],
          iconAnchor: [13, 13]
        }),
        title: el.querySelector('.sear-stock__name').textContent
      }).addTo(map);
      m.bindPopup('<strong>' + el.querySelector('.sear-stock__name').textContent + '</strong><br>' +
                  el.querySelector('.sear-stock__meta').textContent);
      markers.push({ el: el, marker: m });
    });

    if (markers.length) {
      map.fitBounds(L.featureGroup(markers.map(function (m) { return m.marker; })).getBounds(), { padding: [40, 40] });
    } else {
      map.setView([54.5, -3], parseInt(box.dataset.zoom, 10) || 5);
    }
  }

  function load() {
    if (loading || map) return;
    loading = true;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = CSS;
    document.head.appendChild(link);
    var s = document.createElement('script');
    s.src = JS;
    s.onload = build;
    s.onerror = function () { box.hidden = true; };
    document.head.appendChild(s);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { load(); io.disconnect(); } });
    }, { rootMargin: '200px' });
    io.observe(box);
  } else {
    load();
  }

  // Filtering drives the list and the pins together.
  var search = document.querySelector('[data-stock-search]');
  var country = document.querySelector('[data-stock-country]');
  var none = document.querySelector('[data-stock-none]');

  function apply() {
    var q = (search && search.value || '').trim().toLowerCase();
    var c = (country && country.value || '').toLowerCase();
    var shown = 0;

    items().forEach(function (el) {
      var hay = [el.dataset.name, el.dataset.meta, el.dataset.postcode, el.dataset.country].join(' ');
      var ok = (!q || hay.indexOf(q) !== -1) && (!c || el.dataset.country === c);
      el.hidden = !ok;
      if (ok) shown++;
    });

    if (none) none.hidden = shown !== 0;

    if (map) {
      var visible = [];
      markers.forEach(function (m) {
        if (m.el.hidden) { map.removeLayer(m.marker); }
        else { m.marker.addTo(map); visible.push(m.marker); }
      });
      if (visible.length) {
        map.fitBounds(L.featureGroup(visible).getBounds(), { padding: [40, 40] });
      }
    }
  }

  if (search) search.addEventListener('input', apply);
  if (country) country.addEventListener('change', apply);
})();

  } catch(e) { console.error(e); }
})();
})();
